import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";
import { toast } from "react-toastify";
import { errorHandling } from "../../helper";

const userSlice = createSlice({
  name: "auth",
  initialState: {
    loading: false,
    user: {},
    userList: [],
  },
  reducers: {
    loading: (state, action) => {
      state.loading = action.payload;
    },
    userList: (state, action) => {
      state.userList = action.payload;
    },
  },
});

export const { userList, loading } = userSlice.actions;

export const getUserList = (navigate) => async (dispatch) => {
  try {
    dispatch(loading(true));
    const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/get_users`;
    const { data } = await axios.get(url, {
      headers: {
        Authorization: localStorage.getItem("token"),
      },
    });
    dispatch(userList(data?.Users));
    dispatch(loading(false));
    navigate("/");
  } catch (error) {
    toast.error(error?.response?.data?.error);
    dispatch(loading(false));
    errorHandling(error);
  }
};

export const updateUser = (id, formData, handleCloseUpdateForm) => async (dispatch) => {
    try {
      dispatch(loading(true));
      const url = `${process.env.REACT_APP_API_BASE_URL}/admin-auth/update_user/${id}`;
      const { data } = await axios.post(url, formData, {
        headers: {
          Authorization: localStorage.getItem("token"),
        },
      });
      dispatch(loading(false));
      handleCloseUpdateForm();
    } catch (error) {
      toast.error(error?.response?.data?.error);
      dispatch(loading(false));
      errorHandling(error);
    }
  };

export default userSlice.reducer;
